var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo",attrs:{"to":{name: 'home'}}},[_c('img',{attrs:{"src":_vm.src,"alt":"Rbns"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }